// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"akJ6i":[function(require,module,exports,__globalThis) {
var _mainScss = require("../scss/main.scss");
"use strict";
async function getEndpoint(prefix) {
    let lastIndex = prefix.lastIndexOf('-');
    let pre = prefix.slice(0, lastIndex);
    let post = prefix.slice(lastIndex + 1);
    return `/api/v1/${pre}/${post}`;
}
async function getData(endpoint, params = {}) {
    params["format"] = "rows";
    console.log("requesting data");
    let response = await fetch(`${endpoint}?${new URLSearchParams(params)}`);
    console.log("received chart data");
    let data = await response.json();
    console.log("deserialized data");
    console.log(data);
    return data;
}
const labels = {
    gas_day: "Gastag",
    gas_week: "Gaswoche",
    gas_monat: "Gasmonat",
    gas_quartal: "Gasquartal",
    gas_jahr: "Gasjahr",
    flow_norway: "Norwegen",
    flow_denmark: "D\xe4nemark",
    flow_benelux: "Belux",
    flow_netherlands: "Niederlande",
    flow_france: "Frankreich",
    flow_switzerland: "Schweiz",
    flow_czechia: "Tschechien",
    flow_nordstream: "Nordstream",
    flow_austria: "\xd6sterreich",
    flow_poland: "Polen",
    import_norway: "Norwegen",
    import_denmark: "D\xe4nemark",
    import_benelux: "Belux",
    import_netherlands: "Niederlande",
    import_france: "Frankreich",
    import_switzerland: "Schweiz",
    import_czechia: "Tschechien",
    import_nordstream: "Nordstream",
    import_austria: "\xd6sterreich",
    import_poland: "Polen",
    slp_consumption: "SLP-Verbrauch",
    rlm_consumption: "RLM-Verbrauch",
    gas_in_storage: "Speicherf\xfcllst\xe4nde",
    storage: "N/A",
    production: "N/A"
};
async function makeTable(prefix, tableData) {
    console.log(tableData);
    let tableDiv = $(`#${prefix}-table`);
    let columns = [];
    tableData.data.slice(0, 1)[0].forEach((element, index)=>{
        let column = {
            title: labels[element]
        };
        if (index > 0) column.render = DataTable.render.number('.', ',', 4, '');
        columns.push(column);
    });
    let data = tableData.data.slice(1);
    let minDate = new DateTime($('#min-date-input'), {
        format: 'YYYY-MM-DD',
        minDate: new Date(data[0][0])
    });
    minDate.val(data[0][0]);
    let maxDate = new DateTime($('#max-date-input'), {
        format: 'YYYY-MM-DD',
        maxDate: new Date(data[data.length - 1][0])
    });
    maxDate.val(data[data.length - 1][0]);
    let table = tableDiv.DataTable({
        data: data,
        columns: columns,
        deferRender: true,
        destroy: true,
        pagingType: "full_numbers",
        language: {
            searchPlaceholder: "Daten durchsuchen",
            search: "_INPUT_",
            paginate: {
                first: "Erste",
                previous: "Zur\xfcck",
                next: "N\xe4chste",
                last: "Letzte"
            },
            thousands: ",",
            zeroRecords: "Keine passenden Eintr\xe4ge gefunden",
            emptyTable: "Keine Daten in der Tabelle vorhanden",
            info: "_START_ bis _END_ von _TOTAL_ Eintr\xe4gen",
            infoEmpty: "Keine Daten vorhanden",
            infoFiltered: "(gefiltert von _MAX_ Eintr\xe4gen)",
            lengthMenu: "_MENU_ Eintr\xe4ge anzeigen",
            loadingRecords: "Wird geladen ..",
            processing: "Bitte warten .."
        },
        responsive: true,
        buttons: [
            {
                extend: "csv",
                filename: function() {
                    return makeFilename();
                }
            },
            {
                extend: "excel",
                filename: function() {
                    return makeFilename();
                }
            }
        ],
        lengthChange: true,
        dom: 'lrtip'
    });
    // Add the download buttons
    table.buttons().container().addClass("hidden").appendTo(tableDiv.parent().parent());
    return {
        table: table,
        minDate: minDate,
        maxDate: maxDate
    };
}
function makeFilename() {
    let pre = $("h1")[0].innerText;
    let resEl = document.getElementById("resolution");
    let res = resEl.options[resEl.selectedIndex].text;
    let min = document.getElementById("min-date-input").value;
    let max = document.getElementById("max-date-input").value;
    return `${pre} - ${res} - ${min} bis ${max}`;
}
async function makeChart(prefix, chartData) {
    console.log(`Making plot for ${prefix}`);
    Highcharts.setOptions({
        lang: {
            decimalPoint: ',',
            thousandsSep: '.',
            loading: 'Daten werden geladen...',
            months: [
                'Januar',
                'Februar',
                "M\xe4rz",
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember'
            ],
            weekdays: [
                'Sonntag',
                'Montag',
                'Dienstag',
                'Mittwoch',
                'Donnerstag',
                'Freitag',
                'Samstag'
            ],
            shortMonths: [
                'Jan',
                'Feb',
                "M\xe4r",
                'Apr',
                'Mai',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Okt',
                'Nov',
                'Dez'
            ],
            exportButtonTitle: "Exportieren",
            printButtonTitle: "Drucken",
            rangeSelectorFrom: "Von",
            rangeSelectorTo: "Bis",
            rangeSelectorZoom: "Zeitraum",
            downloadPNG: 'Download als PNG-Bild',
            downloadJPEG: 'Download als JPEG-Bild',
            downloadPDF: 'Download als PDF-Dokument',
            downloadSVG: 'Download als SVG-Bild',
            resetZoom: "Zoom zur\xfccksetzen",
            resetZoomTitle: "Zoom zur\xfccksetzen"
        }
    });
    let chartType;
    let yAxisMin;
    let yAxisMax;
    let data = chartData.data;
    if (prefix === "imports-timeseries") {
        chartType = "area";
        yAxisMin = 0;
    } else if (prefix === "consumption-timeseries") {
        yAxisMin = 0;
        chartType = "line";
    } else {
        chartType = "line";
        yAxisMin = -1;
    }
    let series = [];
    console.log("Let's make the actual chart");
    let chart = Highcharts.stockChart(`${prefix}-plot`, {
        chart: {
            type: chartType
        },
        title: {},
        xAxis: {
            type: "datetime",
            labels: {
                formatter: function() {
                    console.log(this.value);
                    return new Date(this.value).toLocaleDateString("de-DE");
                }
            },
            events: {
                afterSetExtremes (e) {
                    let event = new Event("dashboardMinMax", {
                        bubbles: true
                    });
                    event.min = e.min;
                    event.max = e.max;
                    document.body.dispatchEvent(event);
                    console.log(e);
                    console.log(e);
                }
            }
        },
        tooltip: {
            useHTML: true,
            headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
            pointFormatter: function() {
                return `<tr><td style="color: ${this.color}">${labels[this.series.name]}</td>` + `<td style="text-align: right"><b>${this.y.toLocaleString("de-DE", {
                    minimumFractionDigits: 4
                })} TWh</b></td></tr>`;
            },
            footerFormat: '</table>',
            valueDecimals: 2,
            shared: true,
            split: false
        },
        yAxis: {
            min: yAxisMin,
            max: yAxisMax,
            title: {
                text: "TWh"
            },
            opposite: false
        },
        rangeSelector: {
            buttons: [
                {
                    count: 1,
                    type: 'month',
                    text: '1M'
                },
                {
                    count: 5,
                    type: 'month',
                    text: '5M'
                },
                {
                    type: 'all',
                    text: 'Alles'
                }
            ],
            inputEnabled: false,
            selected: 2
        },
        plotOptions: {
            area: {
                stacking: 'normal'
            }
        },
        credits: {
            enabled: false
        },
        navigator: {
            enabled: true,
            series: series
        },
        series: series,
        data: {
            rows: data
        },
        exporting: {
            enabled: false
        },
        legend: {
            enabled: true,
            labelFormatter: function() {
                return `${labels[this.name]}`;
            }
        }
    });
    console.log("The chart should be ready");
    return chart;
}
async function updateView(prefix, resolution, chart, table) {
    let params = {
        resolution: resolution
    };
    let endpoint = await getEndpoint(prefix);
    let dataset = await getData(endpoint, params);
    chart.update({
        data: {
            rows: dataset.data
        }
    });
    let tableDiv = $(`#${prefix}-table`);
    tableDiv.dataTable().fnClearTable();
    $(tableDiv.dataTable().api().column(0).header()).html(labels[dataset.data[0][0]]);
    tableDiv.dataTable().fnAddData(dataset.data);
}
async function makeView(prefix, params = {}) {
    console.log(`Making view for ${prefix}`);
    let endpoint = await getEndpoint(prefix);
    let data = await getData(endpoint, params);
    let chart = await makeChart(prefix, data);
    let tableObjects = await makeTable(prefix, data);
    $.fn.dataTable.ext.search.push(function(settings, data, dataIndex) {
        console.log("called search");
        var min = tableObjects.minDate.val();
        var max = tableObjects.maxDate.val();
        var date = new Date(data[0]);
        if (min === null && max === null || min === null && date <= max || min <= date && max === null || min <= date && date <= max) return true;
        return false;
    });
    // Refilter the table and chart
    console.log(tableObjects.maxDate);
    $('#min-date-input').on('change', function(e) {
        tableObjects.table.draw();
        let min = Date.parse($('#min-date-input').val());
        let max = Date.parse($('#max-date-input').val());
        chart.xAxis[0].setExtremes(min, max);
    });
    $('#max-date-input').on('change', function(e) {
        tableObjects.table.draw();
        let min = Date.parse($('#min-date-input').val());
        let max = Date.parse($('#max-date-input').val());
        chart.xAxis[0].setExtremes(min, max);
    });
    $('#max-date-input').on('keyup change', function(e) {
        tableObjects.table.draw();
    });
    // Set up custom image download buttons
    [
        "jpeg",
        "png"
    ].forEach((fileFormat)=>{
        $(`#${prefix}-download-${fileFormat}`).on('click', function(e) {
            chart.exportChart({
                type: `image/${fileFormat}`,
                filename: makeFilename()
            });
        });
    });
    // Set up custom tabular download buttons
    [
        "csv",
        "xlsx"
    ].forEach((fileFormat, index)=>{
        $(`#${prefix}-download-${fileFormat}`).on('click', function(e) {
            tableObjects.table.buttons(index).trigger();
        });
    });
    $('#resolution').on('change', function(e) {
        let resolution = $(e.target).val();
        updateView(prefix, resolution, chart, tableObjects.table);
    });
    document.addEventListener("dashboardMinMax", function(e) {
        let rangeHasChanged = false;
        let newMax = Highcharts.dateFormat('%Y-%m-%d', new Date(e.max));
        let oldMax = $('#max-date-input').val();
        if (newMax != oldMax) {
            $('#max-date-input').val(newMax);
            tableObjects.maxDate.val(newMax);
            rangeHasChanged = true;
        }
        let newMin = Highcharts.dateFormat('%Y-%m-%d', new Date(e.min));
        let oldMin = $('#min-date-input').val();
        console.log(`new min ${newMin}`);
        if (newMin != oldMin) {
            $('#min-date-input').val(newMin);
            tableObjects.minDate.val(newMin);
            console.log(tableObjects.minDate);
            rangeHasChanged = true;
        }
        console.log(`old: ${oldMin} new: ${newMin}`);
        console.log(e);
        if (rangeHasChanged) {
            console.log("range changed");
            tableObjects.table.search();
            tableObjects.table.draw();
            console.log("grgert");
        }
    });
    return tableObjects;
}
function makeViews() {
    document.addEventListener("DOMContentLoaded", function() {
        [
            "imports-timeseries",
            "flows-timeseries",
            "storage-timeseries",
            "consumption-timeseries"
        ].forEach((prefix)=>{
            if ($(`#${prefix}-dataview`).length) makeView(prefix);
        });
    });
}
window["GasDashboard"] = {
    makeViews: makeViews
};

},{"../scss/main.scss":"2O3Lo"}],"2O3Lo":[function() {},{}]},["akJ6i"], "akJ6i", "parcelRequirefead", {})

//# sourceMappingURL=main.js.map
